// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Satoshi-Regular */
@font-face {
  font-family: 'Satoshi';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Regular.woff2') format('woff2'),url('https://fonts.frete.com/satoshi/files/Satoshi-Regular.woff') format('woff');
}
/* Satoshi-Medium */
@font-face {
  font-family: 'Satoshi';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Medium.woff2') format('woff2'), url('https://fonts.frete.com/satoshi/files/Satoshi-Medium.woff') format('woff');
}
/* Satoshi-Bold */
@font-face {
  font-family: 'Satoshi';
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Bold.woff2') format('woff2'), url('https://fonts.frete.com/satoshi/files/Satoshi-Bold.woff') format('woff');
}
`, "",{"version":3,"sources":["webpack://./node_modules/@frete.com/fuel-fonts/satoshi/fontface.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wKAAwK;AAC1K;AACA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uKAAuK;AACzK;AACA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mKAAmK;AACrK","sourcesContent":["/* Satoshi-Regular */\n@font-face {\n  font-family: 'Satoshi';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Regular.woff2') format('woff2'),url('https://fonts.frete.com/satoshi/files/Satoshi-Regular.woff') format('woff');\n}\n/* Satoshi-Medium */\n@font-face {\n  font-family: 'Satoshi';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Medium.woff2') format('woff2'), url('https://fonts.frete.com/satoshi/files/Satoshi-Medium.woff') format('woff');\n}\n/* Satoshi-Bold */\n@font-face {\n  font-family: 'Satoshi';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 700;\n  src: url('https://fonts.frete.com/satoshi/files/Satoshi-Bold.woff2') format('woff2'), url('https://fonts.frete.com/satoshi/files/Satoshi-Bold.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
